<template>
  <div class="smy__card-full-box page-org" ref="infoBox">
    <Card class="question" :bordered="true">
      <h2 class="theme">{{ theme }}</h2>
      <div class="question-title" v-html="title"></div>
      <div
        v-for="(item, index) in controlList"
        :key="index"
        v-if="typeShow"
        :class="item.tooltip ? 'required' : ''"
        style="margin-bottom: 10px"
      >
        <!-- <Tooltip content="此处有必填项" placement="right" :always="item.tooltip" :disabled="!item.tooltip"> -->
        <CustomControl
          :type="item.type"
          :required="item.is_required"
          :name="item.name"
          :fvs="item.fvs"
          :content="item.content"
          :item="item"
          @change="getForm($event)"
        />
        <!-- </Tooltip> -->
      </div>
      <Row
        v-if="!typeShow"
        v-for="(item, index) in form.surveyAnswerNodes"
        :key="index"
        class="rowList"
        :style="{
          borderBottom:
            index === form.surveyAnswerNodes.length - 1
              ? '1px solid #dfdfdf'
              : '',
        }"
      >
        <Col span="24">
          <p style="font-size: 14px; color: #333; font-weight: 600">
            Q{{ index + 1 }}：
            {{ item.tfname }}
            [
            {{
              item.tftype === 1
                ? '单选框'
                : item.tftype === 2
                ? '多选题'
                : item.tftype === 3
                ? '填空题'
                : item.tftype === 4
                ? '下拉题'
                : item.tftype === 5
                ? '标题'
                : item.tftype === 6
                ? '分割线'
                : item.tftype === 7
                ? '说明文本'
                : item.tftype === 8
                ? '评分'
                : item.tftype === 9
                ? '横向填空'
                : '表格'
            }}
            ]
          </p>
          <p v-html="item.infeedFillBlankText" v-if="item.tftype === 9"></p>
          <p v-for="(ele, index2) in item.fvs" :key="index2" v-else>
            {{ ele.name ? ele.name + ':' : '' }} {{ ele.value }}
          </p>
        </Col>
      </Row>
      <div style="text-align: center" v-if="typeShow">
        <Button type="primary" :loading="loading" @click="save">提交</Button>
      </div>
    </Card>
    <div class="technical-support">
      问卷调查服务由
      <a href="//www.danxiaoer.net/" target="_blank">单小二</a>
      提供技术支持
      <a href="//www.danxiaoer.net/" target="_blank">400-6226-526</a>,
      GN集团助听器售后服务电话：<a target="_blank" href="https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzI1MjQwNDY0MA==&scene=124&uin=&key=&devicetype=Windows+10+x64&version=63030073&lang=zh_CN&a8scene=7&fontgear=2">400-8882440</a>
    </div>
  </div>
</template>
<script>
import CustomControl from './CustomControl'
import FingerprintJS from '@fingerprintjs/fingerprintjs'

export default {
  name: 'questionnaire',
  components: {
    CustomControl,
  },
  data() {
    return {
      controlList: [],
      formArr: [],
      typeShow: true,
      form: {},
      CheckArr: {}, // 特殊处理多选
      surveyId: '',
      nodeTmplId: '',
      theme: '',
      title: '',
      end_time: '',
      startTime: '',
      time_cost: '',
      filler_id: '',
      required: [],
      required1: [],
      loading: false,
    }
  },
  watch: {
    theme(v) {
      document.title = this.theme
    },
  },
  async mounted() {
    const fpPromise = FingerprintJS.load()
    const fp = await fpPromise
    const result = await fp.get()
    const visitorId = result.visitorId
    this.filler_id = visitorId
    // let canvas = document.createElement('canvas')
    // let ctx = canvas.getContext('2d')
    // let txt = '单小二'
    // ctx.textBaseline = 'top'
    // ctx.font = "14px 'Arial'"
    // ctx.textBaseline = 'tencent'
    // ctx.fillStyle = '#f60'
    // ctx.fillRect(125, 1, 62, 20)
    // ctx.fillStyle = '#069'
    // ctx.fillText(txt, 2, 15)
    // ctx.fillStyle = 'rgba(102, 204, 0, 0.7)'
    // ctx.fillText(txt, 4, 17)
    // let b64 = canvas.toDataURL().replace('data:image/png;base64,', '')
    // let bin = atob(b64)
    // this.filler_id = this.bin2hex(bin.slice(-16, -12))
    this.surveyId = this.$route.params.surveyId
    this.nodeTmplId = this.$route.params.nodeTmplId
    this.getType()
    this.startTime = this.getCurrentTime()
  },
  methods: {
    getType() {
      this.$http
        .get(`/answer/byFiller/${this.surveyId}/${this.filler_id}`)
        .then((res) => {
          if (!res.success) {
            this.getSurvey()
            this.typeShow = true
          } else {
            this.typeShow = false
            this.form = res.data
            this.form.surveyAnswerNodes.forEach((item) => {
              if (item.tftype === 9) {
                let count = 0
                item.infeedFillBlankText = item.content.replace(
                  /_+/gi,
                  (match) => {
                    let str = item.fvs[count] ? item.fvs[count].value : ''
                    count++
                    return '<span class="black-line">' + str + '</span>'
                  }
                )
                // console.log(this.infeedFillBlankText)
                item.infeedFillBlankText = item.infeedFillBlankText.replace(
                  /(\r\n|\n|\r)/gm,
                  '</br>'
                )
              }
            })
            this.title = res.data.survey_title
            this.theme = res.data.survey_theme
          }
        })
    },
    getCurrentTime() {
      let date = new Date() // 当前时间
      let month = this.zeroFill(date.getMonth() + 1) // 月
      let day = this.zeroFill(date.getDate()) // 日
      let hour = this.zeroFill(date.getHours()) // 时
      let minute = this.zeroFill(date.getMinutes()) // 分
      let second = this.zeroFill(date.getSeconds()) // 秒
      // 当前时间
      let curTime =
        date.getFullYear() +
        '-' +
        month +
        '-' +
        day +
        ' ' +
        hour +
        ':' +
        minute +
        ':' +
        second
      return curTime
    },
    zeroFill(i) {
      if (i >= 0 && i <= 9) {
        return '0' + i
      } else {
        return i
      }
    },
    getSeconds(date1) {
      let date2 = new Date() // 结束时间
      let date3 = (date2.getTime() - new Date(date1).getTime()) / 1000
      return date3
    },
    getSurvey() {
      this.$http
        .get('/survey/get/setting', {
          params: {
            surveyId: this.surveyId,
            nodeTmplId: this.nodeTmplId,
          },
        })
        .then((res) => {
          if (res.success) {
            this.controlList = res.data.nodeList
            this.controlList.forEach((item) => {
              this.$set(item, 'tooltip', false)
            })
            this.title = res.data.title
            this.theme = res.data.theme
            this.controlList.forEach((item) => {
              if (
                item.is_required === 1 &&
                item.type !== 9 &&
                item.type !== 10
              ) {
                // 普通情况（非横向填空和表格）
                this.required.push(item.id)
              } else if (
                item.is_required === 1 &&
                (item.type === 9 || item.type === 10)
              ) {
                // 特殊情况（横向填空和表格）
                item.fvs.forEach((ele) => {
                  if (ele.is_required === 1) {
                    this.required1.push(ele.ctrl_id)
                  }
                })
              }
            }) // 归类数据是否必填
          }
        })
    },
    bin2hex(str) {
      let ret = ''
      let r = /[0-9a-zA-Z_.~!*()]/
      for (let i = 0, l = str.length; i < l; i++) {
        if (r.test(str.charAt(i))) {
          ret += str.charCodeAt(i).toString(16)
        } else {
          ret += encodeURIComponent(str.charAt(i)).replace(/%/g, '')
        }
      }
      return ret
    },
    back() {
      this.$router.back()
    },
    getArr(arr, value) {
      let re = arr.some(function (item) {
        if (value.fieldId && item.fieldId === value.fieldId) {
          return true
        } else if (value.ctrlId && item.ctrlFieldId === value.ctrlFieldId) {
          return true
        } else {
          return false
        }
      })
      return re
    },
    getForm(value) {
      console.log(value)
      if (value.type !== 2) {
        if (value.type !== 9 && value.type !== 10) {
          this.required.forEach((ele) => {
            if (ele === value.fieldId) {
              this.controlList.forEach((item) => {
                if (item.id === ele) {
                  item.tooltip = false
                }
              })
            }
          }) // 取消校验样式
        } else {
          this.required1.forEach((ele) => {
            if (ele === value.ctrlId) {
              this.controlList.forEach((item) => {
                if (item.type === 9 || item.type === 10) {
                  item.fvs.forEach((v) => {
                    if (v.ctrl_id === ele) {
                      item.tooltip = false
                    }
                  })
                }
              })
            }
          }) // 校验特殊数据
        }
        if (this.getArr(this.formArr, value)) {
          this.formArr.forEach((item, index) => {
            if (value.fieldId && value.fieldId === item.fieldId) {
              this.formArr[index] = value
            } else if (value.ctrlId && value.ctrlFieldId === item.ctrlFieldId) {
              this.formArr[index] = value
            }
          })
        } else {
          this.formArr.push(value)
        }
      } else {
        this.required.forEach((ele) => {
          if (ele === value.id) {
            this.controlList.forEach((item) => {
              if (item.id === ele) {
                item.tooltip = false
              }
            })
          }
        }) // 取消校验样式
        this.CheckArr[value.id] = value.arr
      }
    },
    some(arr, value) {
      let result = arr.some((item) => {
        if (item.fieldId === value) {
          return true
        }
      })
      return result
    },
    some1(arr, value) {
      let result = arr.some((item) => {
        if (item.ctrlFieldId === value) {
          return true
        }
      })
      return result
    },
    save() {
      this.loading = true
      this.controlList.forEach((item) => {
        item.tooltip = false
      }) // 将校验的提示关掉
      this.end_time = this.getCurrentTime()
      this.time_cost = parseInt(this.getSeconds(this.startTime))
      let data = []
      data = data.concat(this.formArr)
      for (let key in this.CheckArr) {
        data.push(...this.CheckArr[key])
      }
      data.forEach((item, index) => {
        if (
          item.value === '' ||
          item.value === null ||
          item.value === undefined
        ) {
          data.splice(index, 1)
        }
      }) // 去除空项
      this.required.forEach((ele) => {
        if (!this.some(data, ele)) {
          this.controlList.forEach((item) => {
            if (item.id === ele) {
              item.tooltip = true
            }
          })
        }
      }) // 校验普通数据
      this.required1.forEach((ele) => {
        if (!this.some1(data, ele)) {
          this.controlList.forEach((item) => {
            if (item.type === 9 || item.type === 10) {
              item.fvs.forEach((v) => {
                if (v.ctrl_id === ele) {
                  item.tooltip = true
                }
              })
            }
          })
        }
      }) // 校验特殊数据
      for (let i = 0; i < this.controlList.length; i++) {
        if (this.controlList[i].tooltip) {
          this.loading = false
          this.$Message.error('请填写必填项')
          return false
        }
      }
      this.$http
        .post('/answer/save', {
          surveyId: this.surveyId,
          nodeTmplId: this.nodeTmplId,
          start_time: this.startTime,
          end_time: this.end_time,
          time_cost: this.time_cost,
          filler_id: this.filler_id,
          nodeValueList: data,
        })
        .then((res) => {
          this.loading = false
          if (res.success) {
            this.$Message.success('提交成功!')
            this.getType()
          } else {
            this.$Message.error(res.message)
          }
        })
    },
  },
}
</script>
<style lang="less" scoped>
.smy__card-full-box {
  padding: 30px 0;
  background-color: #f8f8f9;
}
.page-org {
  min-height: 100%;
  position: relative;
  padding-bottom: 60px;
  .technical-support {
    position: absolute;
    bottom: 0;
    width: 100%;
    text-align: center;
    padding: 20px 0;
    color: #bbb1b1;
    a {
      color: #2d8cf0;
      text-decoration: underline;
    }
  }
}
.question {
  width: 1200px;
  margin: 0 auto;
}
.theme {
  font-size: 30px;
  text-align: center;
}
.question-title {
  padding: 15px;
}
.rowList {
  padding: 10px;
  border-top: 1px solid #dfdfdf;
}
.required {
  border: 1px solid #ed4014;
  border-radius: 5px;
}
</style>
<style>
.black-line {
  padding: 0 3px;
  border-bottom: 1px solid;
}
</style>



// WEBPACK FOOTER //
// src/pages/questionnaire/questionnaire/index.vue